export default {
  // Navigation
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.register': 'Register',
  'nav.blog': 'Blog',
  'nav.tryFree': 'Try Free',
  
  // Hero Section
  'hero.title1': 'Complete Control of',
  'hero.title2': 'Your Gym Management',
  'hero.description': 'An integrated management system that provides you with a professional dashboard to track revenues, memberships, attendance, and invoices in one place. With advanced analytical reports for better decision-making.',
  'hero.tryFree': 'Try Free for 14 Days',
  'hero.requestDemo': 'Request Demo',
  'hero.revenue': 'Revenue',
  'hero.fromLastMonth': 'from last month',
  'hero.totalMemberships': 'Total Memberships',
  'hero.active': 'Active',
  'hero.inactive': 'Inactive',
  'hero.newMemberships': 'New Memberships',
  'hero.thisMonth': 'This month',
  
  // Why Choose Section
  'whyChoose.title': 'Why Choose Us',
  'whyChoose.description': 'An integrated system that meets all your gym needs with an easy-to-use interface and advanced features',
  'whyChoose.timeSaving': 'Time Saving',
  'whyChoose.timeSavingDesc': 'Automate daily operations and reduce time spent on administrative tasks by up to 70%',
  'whyChoose.analytics': 'Advanced Analytics',
  'whyChoose.analyticsDesc': 'Comprehensive view of your gym performance with detailed reports and customizable dashboards',
  'whyChoose.experience': 'Premium Customer Experience',
  'whyChoose.experienceDesc': 'Member app that allows class booking, progress tracking, and direct communication with trainers',
  
  // Services Section
  'services.title': 'Services',
  'services.description': 'A comprehensive set of solutions designed specifically to meet the needs of gyms',
  'services.membership.title': 'Membership Management',
  'services.membership.description': 'Complete management of member data, subscriptions, automatic renewal, and membership expiration notifications',
  'services.membership.feature1': 'Custom member profiles',
  'services.membership.feature2': 'Subscription management',
  'services.membership.feature3': 'Electronic membership cards',
  'services.scheduling.title': 'Class Scheduling',
  'services.scheduling.description': 'Easy and effective class scheduling with appointment booking and resource management',
  'services.scheduling.feature1': 'Advanced scheduling for classes and trainers',
  'services.scheduling.feature2': 'Online booking system',
  'services.scheduling.feature3': 'Automated appointment reminders',
  'services.payment.title': 'Payment Management',
  'services.payment.description': 'Integrated payment system supporting various payment methods with detailed financial reports',
  'services.payment.feature1': 'Multiple payment methods support',
  'services.payment.feature2': 'Electronic invoices and receipts',
  'services.payment.feature3': 'Financial and tax reports',
  'services.analytics.title': 'Analytics & Reports',
  'services.analytics.description': 'Advanced analytical dashboards and detailed reports to help you make informed decisions',
  'services.analytics.feature1': 'Revenue and expense analytics',
  'services.analytics.feature2': 'Attendance and activity reports',
  'services.analytics.feature3': 'Key performance indicators',
  'services.memberApp.title': 'Member App',
  'services.memberApp.description': 'Dedicated app for members to book classes, track progress, and communicate directly with trainers',
  'services.memberApp.feature1': 'Book classes and appointments',
  'services.memberApp.feature2': 'Track progress and goals',
  'services.memberApp.feature3': 'Direct communication with trainers',
  'services.inventory.title': 'Inventory Management',
  'services.inventory.description': 'Easy inventory and product management with detailed sales and inventory reports',
  'services.inventory.feature1': 'Product catalog management',
  'services.inventory.feature2': 'Integrated point of sale',
  'services.inventory.feature3': 'Sales and profit reports',
  
  // Statistics Section
  'stats.revenue': 'Revenue',
  'stats.netProfit': 'Net Profit',
  'stats.members': 'Members',
  'stats.fromPreviousMonth': 'from previous month',
  'stats.income': 'Income',
  'stats.expenses': 'Expenses',
  'stats.organicSources': 'Organic Sources',
  'stats.socialMedia': 'Social Media',
  'stats.friends': 'Friends',
  'stats.directVisit': 'Direct Visit',
  'stats.calls': 'Calls',
  'stats.billingStatus': 'Invoice Status',
  'stats.newMembership': 'New Membership',
  'stats.newSubscription': 'New Subscription',
  'stats.newSession': 'New Session',
  'stats.renewal': 'Renewal',
  'stats.extension': 'Extension',
  'stats.draft': 'Draft',
  'stats.sent': 'Sent',
  'stats.paid': 'Paid',
  'stats.partiallyPaid': 'Partially Paid',
  'stats.overdue': 'Overdue',
  
  // Registration Section
  'register.title1': 'Start Your Journey with',
  'register.title2': '5vix',
  'register.title3': 'Today',
  'register.description': 'Register now and get a free 14-day trial period. No credit card required, no commitments.',
  'register.quickSetup': 'Quick Setup',
  'register.quickSetupDesc': 'Start using the system in just minutes, with continuous technical support',
  'register.dataSafe': 'Your Data is Safe',
  'register.dataSafeDesc': 'Fully secure system with data encryption and regular backups',
  'register.support': '24/7 Technical Support',
  'register.supportDesc': 'Specialized support team ready to help you anytime',
  'register.formTitle': 'Create New Account',
  'register.firstName': 'First Name',
  'register.lastName': 'Last Name',
  'register.gymName': 'Gym Name',
  'register.email': 'Email',
  'register.phone': 'Phone Number',
  'register.package': 'Package',
  'register.selectPackage': 'Select Package',
  'register.basic': 'Basic',
  'register.professional': 'Professional',
  'register.integrated': 'Integrated',
  'register.createAccount': 'Create Account',
  
  // Testimonials Section
  'testimonials.title': 'What Our Customers Say',
  'testimonials.description': 'Opinions of gym owners who use the 5vix system',
  'testimonials.customer1.name': 'Fahad Jamal',
  'testimonials.customer1.role': 'Owner of Fit Punch Gym',
  'testimonials.customer1.text': 'We have been in the field for about 6 years, and we were suffering from problems with salaries and attendance. But after the Five Vix system, everything became easy from the mobile, and support is always quick to solve any problem or modification',
  'testimonials.customer2.name': 'Ahmed Khairat',
  'testimonials.customer2.role': 'Owner of Cyborg Calisthenics',
  'testimonials.customer2.text': 'Mastery and continuous development and excellent service summarize my experience with the application. I advise anyone looking to develop to start their journey with the application',
  'testimonials.customer3.name': 'Abdullah Al-Rashid',
  'testimonials.customer3.role': 'Owner of Power Gym Chain',
  'testimonials.customer3.text': 'Excellent technical support, and continuous updates add new features constantly. Reports and analytics helped me understand my business better and make smarter decisions.',
  
  // Blog Section
  'blog.title': 'Fitness & Wellness Blog',
  'blog.subtitle': 'Expert tips, guides, and insights to help you achieve your fitness goals',
  'blog.allArticles': 'All Articles',
  'blog.fitness': 'Fitness',
  'blog.nutrition': 'Nutrition',
  'blog.wellness': 'Wellness',
  'blog.training': 'Training',
  'blog.newsletterTitle': 'Subscribe to Our Newsletter',
  'blog.newsletterDesc': 'Get the latest fitness tips and wellness advice delivered to your inbox',
  'blog.readMore': 'Read More',
  'blog.viewAll': 'View All Articles',
  
  'blog.article1.title': '10 Essential Exercises for Building Strength',
  'blog.article1.excerpt': 'Discover the fundamental exercises that form the foundation of any effective strength training program. Learn proper form and technique to maximize results.',
  
  'blog.article2.title': 'Complete Guide to Meal Planning for Athletes',
  'blog.article2.excerpt': 'Master the art of nutrition planning with our comprehensive guide. Learn how to fuel your body for optimal performance and recovery.',
  
  'blog.article3.title': 'The Importance of Rest and Recovery',
  'blog.article3.excerpt': 'Understanding why rest days are crucial for progress. Learn how to optimize your recovery for better performance and injury prevention.',
  
  'blog.article4.title': 'HIIT Training: Benefits and Best Practices',
  'blog.article4.excerpt': 'Explore the science behind high-intensity interval training and how to incorporate it effectively into your fitness routine.',
  
  'blog.article5.title': 'Home Workout Essentials: No Gym Required',
  'blog.article5.excerpt': 'Get fit from the comfort of your home with these effective exercises and minimal equipment. Perfect for busy schedules.',
  
  'blog.article6.title': 'Protein Intake: How Much Do You Really Need?',
  'blog.article6.excerpt': 'Debunking myths about protein consumption and providing evidence-based recommendations for different fitness goals.',
  
  'blog.article7.title': 'Sleep Optimization for Better Performance',
  'blog.article7.excerpt': 'Learn how quality sleep impacts your fitness results and discover strategies to improve your sleep quality.',
  
  'blog.article8.title': 'Strength Training for Beginners: A Complete Guide',
  'blog.article8.excerpt': 'Everything you need to know to start your strength training journey safely and effectively. From basics to advanced tips.',
  
  'blog.article9.title': 'Flexibility and Mobility: The Missing Link',
  'blog.article9.excerpt': 'Why flexibility training is essential for overall fitness and how to incorporate it into your routine for better results.',
  
  // CTA Section
  'cta.title': 'Ready to Improve Your Gym Management?',
  'cta.description': 'Join thousands of gyms using 5vix to improve operational efficiency and provide an excellent experience for members.',
  'cta.button': 'Start Now for Free',
  
  // Footer
  'footer.description': 'An integrated system for gym management that helps you organize subscriptions, schedule classes, track attendance, and analyze performance with ease.',
  'footer.quickLinks': 'Quick Links',
  'footer.support': 'Support',
  'footer.helpCenter': 'Help Center',
  'footer.faq': 'FAQ',
  'footer.contactUs': 'Contact Us',
  'footer.terms': 'Terms & Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.newsletter': 'Newsletter',
  'footer.newsletterDesc': 'Subscribe to our newsletter to get the latest news and updates',
  'footer.subscribe': 'Subscribe',
  'footer.cookies': 'Cookies',
  'footer.copyright': '© 2025 5vix. All rights reserved.',
  
  // Help Center
  helpCenter: {
    title: 'Help Center',
    subtitle: 'Find answers to your questions and get the support you need',
    searchPlaceholder: 'Search for help...',
    gettingStarted: 'Getting Started',
    membership: 'Membership',
    billing: 'Billing',
    technical: 'Technical',
    mobileApp: 'Mobile App',
    reports: 'Reports',
    frequentlyAsked: 'Frequently Asked Questions',
    noResults: 'No results found. Try different keywords.',
    stillNeedHelp: 'Still Need Help?',
    contactTeam: 'Our support team is here to assist you 24/7',
    emailSupport: 'Email Support',
    callUs: 'Call Us',
    
    faq1: {
      question: 'How do I get started with 5vix?',
      answer: 'Getting started is easy! Simply sign up for a free trial, complete the setup wizard, and you can start managing your gym immediately. Our team will guide you through the initial setup process.'
    },
    faq2: {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards (Visa, Mastercard, American Express), PayPal, and bank transfers. All payments are processed securely through our encrypted payment gateway.'
    },
    faq3: {
      question: 'How do I add new members to the system?',
      answer: 'You can add new members through the Members section in your dashboard. Click "Add Member", fill in their details, select a membership plan, and process the payment. Members will receive a welcome email automatically.'
    },
    faq4: {
      question: 'Can members book classes through the mobile app?',
      answer: 'Yes! Members can download our mobile app, log in with their credentials, and book classes, view schedules, track their progress, and manage their membership directly from their phone.'
    },
    faq5: {
      question: 'How do I set up recurring billing?',
      answer: 'Recurring billing is automatically set up when you create a membership plan. You can configure the billing frequency (monthly, quarterly, annually) and the system will automatically charge members on their renewal date.'
    },
    faq6: {
      question: 'What happens if a payment fails?',
      answer: 'If a payment fails, the system will automatically retry after 3 days. Members will receive email notifications about the failed payment. You can also manually process payments or update payment methods in the member profile.'
    },
    faq7: {
      question: 'How do I integrate with my existing systems?',
      answer: '5vix offers API integration and supports various third-party integrations. Contact our technical support team to discuss your specific integration needs and we will help you set it up.'
    },
    faq8: {
      question: 'Is my data secure?',
      answer: 'Absolutely! We use bank-level encryption (SSL/TLS) to protect all data. Our servers are hosted in secure data centers with 24/7 monitoring, regular backups, and compliance with international data protection standards.'
    },
    faq9: {
      question: 'How do I download the mobile app?',
      answer: 'The 5vix mobile app is available for both iOS and Android. Search for "5vix" in the App Store or Google Play Store, or visit our website for direct download links.'
    },
    faq10: {
      question: 'Can I customize the mobile app branding?',
      answer: 'Yes! With our Professional and Integrated plans, you can customize the app with your gym logo, colors, and branding. Contact our support team to set up custom branding for your mobile app.'
    },
    faq11: {
      question: 'What reports are available?',
      answer: 'We offer comprehensive reports including revenue analysis, membership statistics, attendance tracking, class popularity, trainer performance, and custom reports. All reports can be exported to PDF or Excel.'
    },
    faq12: {
      question: 'Can I schedule automated reports?',
      answer: 'Yes! You can schedule reports to be automatically generated and emailed to you daily, weekly, or monthly. Set up automated reports in the Reports section of your dashboard.'
    }
  },
  
  terms: {
    title: 'Terms and Conditions',
    lastUpdated: 'Last Updated: January 2025',
    section1: {
      title: '1. Acceptance of Terms',
      content1: 'By accessing and using the 5vix gym management system, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not use our services.',
      content2: 'These terms apply to all users of the system, including gym owners, administrators, trainers, and members.'
    },
    section2: {
      title: '2. User Accounts and Registration',
      content: 'To use our services, you must:',
      item1: 'Provide accurate and complete registration information',
      item2: 'Maintain the security of your account credentials',
      item3: 'Notify us immediately of any unauthorized access',
      item4: 'Be responsible for all activities under your account'
    },
    section3: {
      title: '3. Service Description',
      content: '5vix provides a comprehensive gym management platform that includes:',
      item1: 'Member management and tracking',
      item2: 'Class scheduling and booking',
      item3: 'Payment processing and billing',
      item4: 'Performance analytics and reporting',
      item5: 'Mobile app access for members and staff'
    },
    section4: {
      title: '4. Payment Terms',
      content1: 'Subscription fees are billed in advance on a monthly or annual basis. All fees are non-refundable except as required by law.',
      content2: 'You authorize us to charge your payment method for all fees. If payment fails, we may suspend or terminate your access to the service.'
    },
    section5: {
      title: '5. User Responsibilities',
      content: 'Users agree to:',
      item1: 'Use the service only for lawful purposes',
      item2: 'Not interfere with or disrupt the service',
      item3: 'Not attempt to gain unauthorized access to any part of the system',
      item4: 'Comply with all applicable laws and regulations'
    },
    section6: {
      title: '6. Intellectual Property',
      content: 'All content, features, and functionality of the 5vix platform are owned by us and are protected by international copyright, trademark, and other intellectual property laws.'
    },
    section7: {
      title: '7. Limitation of Liability',
      content: 'To the maximum extent permitted by law, 5vix shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.'
    },
    section8: {
      title: '8. Contact Information',
      content: 'If you have any questions about these Terms and Conditions, please contact us:',
      email: 'Email:',
      phone: 'Phone:'
    },
    cta: {
      title: 'Ready to Get Started?',
      subtitle: 'Join thousands of gyms using 5vix to manage their business',
      helpCenter: 'Visit Help Center'
    }
  },

  // Privacy Policy
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: January 2024',
    introduction: 'At 5vix, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our gym management system and related services.',
    section1: {
      title: '1. Information We Collect',
      subtitle1: 'Personal Information',
      content1: 'We collect personal information that you provide directly to us, including your name, email address, phone number, date of birth, payment information, and gym membership details.',
      subtitle2: 'Usage Information',
      content2: 'We automatically collect information about your use of our services, including login times, features accessed, workout data, attendance records, and device information.',
      subtitle3: 'Health and Fitness Data',
      content3: 'With your consent, we may collect health and fitness-related information such as workout routines, body measurements, fitness goals, and progress tracking data.'
    },
    section2: {
      title: '2. How We Use Your Information',
      content: 'We use the information we collect for the following purposes:',
      item1: 'To provide, maintain, and improve our gym management services',
      item2: 'To process your membership payments and manage your account',
      item3: 'To send you important updates, notifications, and promotional materials',
      item4: 'To personalize your experience and provide customized recommendations',
      item5: 'To analyze usage patterns and improve our platform performance'
    },
    section3: {
      title: '3. Information Sharing and Disclosure',
      content: 'We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances: with your consent, to comply with legal obligations, to protect our rights and safety, or with service providers who assist us in operating our platform under strict confidentiality agreements.'
    },
    section4: {
      title: '4. Data Security',
      content: 'We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. This includes encryption, secure servers, regular security audits, and access controls. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.'
    },
    section5: {
      title: '5. Cookies and Tracking Technologies',
      content: 'We use cookies and similar tracking technologies to enhance your experience on our platform. Cookies help us remember your preferences, analyze site traffic, and provide personalized content. You can control cookie settings through your browser, but disabling cookies may limit some features of our services.'
    },
    section6: {
      title: '6. Your Rights and Choices',
      content: 'You have the following rights regarding your personal information:',
      item1: 'Access and review your personal data stored in our system',
      item2: 'Request correction of inaccurate or incomplete information',
      item3: 'Request deletion of your personal data, subject to legal requirements',
      item4: 'Opt-out of marketing communications at any time'
    },
    section7: {
      title: '7. Third-Party Links',
      content: 'Our platform may contain links to third-party websites or services. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any third-party services you access through our platform.'
    },
    section8: {
      title: '8. Changes to This Privacy Policy',
      content: 'We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated policy on our website and updating the "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the updated policy.'
    },
    section9: {
      title: 'Contact Us',
      content: 'If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:'
    },
    cta: {
      title: 'Ready to Get Started?',
      subtitle: 'Join thousands of fitness enthusiasts using 5vix to achieve their goals',
      button: 'Start Free Trial'
    }
  }
};
